import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import 'firebase/compat/functions'
import 'firebase/compat/auth'
import 'firebase/compat/database'
import type { RulesTestEnvironment } from '@firebase/rules-unit-testing'
import { initializeTestEnvironment } from '@firebase/rules-unit-testing'

const firebaseConfig = {
  apiKey: 'AIzaSyDBZwI6ZgFA-4umZcKAp47exuFdH-KI_lU',
  authDomain: 'beatout-2738d.firebaseapp.com',
  databaseURL: 'https://beatout-2738d.firebaseio.com',
  projectId: 'beatout-2738d',
  storageBucket: 'beatout-2738d.appspot.com',
  messagingSenderId: '406464996428',
  appId: '1:406464996428:web:f90a6cab6aaeadbe9340e9',
  measurementId: 'G-TKCTLPVR6E'
}

const app = firebase.initializeApp(firebaseConfig)
let dbImpl = firebase.firestore(app)

// In Jest (ts-jest) the default export value is not a live binding.
// Export a proxy that forwards to the current underlying Firestore instance.
const db: any = new Proxy(
  {},
  {
    get (_target, prop: string) {
      const value = (dbImpl as any)[prop]
      return typeof value === 'function' ? value.bind(dbImpl) : value
    },
    set (_target, prop: string, value: any) {
      ;(dbImpl as any)[prop] = value
      return true
    }
  }
)

let dbReady: Promise<any> = Promise.resolve(db)
const storage = firebase.storage()
let cleanupConnection: () => Promise<void> = async () => {}
let clearDB: () => Promise<void> = async () => {}

if (process.env.NODE_ENV === 'test') {
  // console.warn('Running using the firestore emulator')
  const projectId =
    'beatout-test-' +
    Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

  const emulatorHost = process.env.FIRESTORE_EMULATOR_HOST || '127.0.0.1:9888'
  const [host, portString] = emulatorHost.split(':')
  const port = Number(portString || 9888)

  const allowAllRules = `service cloud.firestore {
    match /databases/{database}/documents {
      match /{document=**} {
        allow read, write: if true;
      }
    }
  }`

  let testEnvPromise: Promise<RulesTestEnvironment> | undefined
  const getTestEnv = () => {
    if (!testEnvPromise) {
      testEnvPromise = initializeTestEnvironment({
        projectId,
        firestore: {
          host,
          port,
          rules: allowAllRules
        }
      })
    }
    return testEnvPromise
  }

  // Use a Firestore instance with allow-all rules for unit tests.
  // This can safely be used outside of any special callback.
  const testDbPromise = getTestEnv().then(env => env.unauthenticatedContext().firestore())
  dbReady = testDbPromise.then(firestore => {
    dbImpl = firestore as any
    return db
  })

  cleanupConnection = async () => {
    const env = await getTestEnv()
    await env.cleanup()
  }

  clearDB = async () => {
    const env = await getTestEnv()
    await env.clearFirestore()
  }
}

export default db
export { storage, cleanupConnection, clearDB, dbReady }
